module.exports = __webpack_public_path__ + "img/logo.92d9f8ef.png";